import React, {useCallback, useEffect, useState} from 'react';
import {ContainerHeader} from "../../module";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import {useDispatch, useSelector} from "react-redux";
import {useHistory, useParams} from "react-router";
import useValidation from "../../../validation/useValidation";
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali';
import {notification} from "../../functions/notification/notificationFunction";
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import {
    initDiscountCodeForm, onDiscountCodeAmountFormChange,
    onDiscountCodeConditionFormChange,
    onDiscountCodeFormChange,
    selDiscountCodeForm
} from "../../../stores/discountCode/slice";
import {discountCodeValidations, FormDiscountCodeInit} from "../../../stores/discountCode/model";
import {createDiscountCode, editDiscountCode, getDiscountCodeById} from "../../../stores/discountCode/thunk";
import {onNoticeFormChange} from "../../../stores/notice/slice";
import {Chip} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import _debounce from "lodash/debounce";
import {getUsersByLastName} from "../../../stores/user/userThunk";
import {getProductsByName} from "../../../stores/product/thunks";
import {selProduct} from "../../../stores/product/slice";

export default function DiscountCode() {

    const discountCode = useSelector(selDiscountCodeForm);

    const { name, code, status, condition, amount } = discountCode;

    const { Count, StartDate, EndDate, Product } = condition;
    const { percent, price } = amount;


    const [discountFor, setDiscountFor] = useState('all');
    const [loading, setLoading] = useState(false);
    const [ productIds, setProductIds ] = useState([])
    const products = useSelector(selProduct);

    const provinces = [
        {
            name: "درصد",
            value: "percent"
        },
        {
            name: "قیمت",
            value: "price"
        }
    ];
    const dispatch = useDispatch();
    const {id} = useParams();
    const history = useHistory();

    const {errors, checkFiled, checkValidation} = useValidation({
        data: discountCodeValidations,
        key: 'discountCodeForm',
    });

    function setParametersMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onDiscountCodeFormChange({name, value}))
    }
    function setParametersConditionMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onDiscountCodeConditionFormChange({name, value}))
    }
    function setParametersAmountMain(event) {
        const {value, name} = event.target;
        checkFiled(name, value);
        dispatch(onDiscountCodeAmountFormChange({name, value}))
    }
    function backToUsers() {
        history.push('/discount-codes');
    }

    const redirectToUsers =()=> history.push("/discount-codes")

    async function addDiscountCode(){
        const formData = new FormData();

        formData.append('name', name)
        formData.append('code', code)
        formData.append('condition[StartDate]', StartDate)
        formData.append('condition[EndDate]', EndDate)
        formData.append('condition[Count]', parseInt(Count))
        formData.append('status', status)
        amount["percent"] ?
            formData.append('amount[percent]', parseInt(percent))
            :
            formData.append('amount[price]', parseInt(price))
        discountFor === "special" && productIds.map((item, i)=>{
            formData.append(`condition[Product][${i}]`, item)
        })
        // const check = await checkValidation(data);
        // if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(createDiscountCode(formData, redirectToUsers))
    }

    async function putDiscountCode(){
        const formData = new FormData();

        formData.append('name', name)
        formData.append('code', code)
        formData.append('condition[StartDate]', StartDate)
        formData.append('condition[EndDate]', EndDate)
        formData.append('condition[Count]', parseInt(Count))
        formData.append('status', status)
        amount["percent"] ?
            formData.append('amount[percent]', parseInt(percent))
            :
            formData.append('amount[price]', parseInt(price))
        discountFor === "special" && productIds.map((item, i)=>{
            formData.append(`condition[Product][${i}]`, item)
        })
        // const check = await checkValidation(data);
        // if (!check) return dispatch(notification("error","خوش آمدید",<h3>فیلد های قرمز رنگ را پر کنید</h3>,false))
        dispatch(editDiscountCode(id, formData, redirectToUsers))
    }

    function setTime(e, name) {
        const value = moment(e).format(`YYYY-MM-DD HH:mm:ss`)
        checkFiled(name, value);
        dispatch(onDiscountCodeConditionFormChange({name, value: value}))
        // setStaticState(prevState => (
        //     {
        //         ...prevState, [name]: e.format(`jYYYY/jMM/jDD`),
        //         [`dateForSend`]: e.format(`YYYY/MM/DD`)
        //     }
        // ));
    }

    const debounceFn = useCallback(_debounce(handleDebounceFn, 1000), []);

    function onChangeSearchInput (event) {
        debounceFn(event.target.value);
    };

    async function handleDebounceFn(inputValue) {
        setLoading(true)
        await dispatch((getProductsByName(inputValue)))
        setLoading(false)
    }

    // console.log('name:',name, 'code:',code, 'status:',status,'count:',parseInt(Count), 'StartDate:',StartDate, 'EndDate:',EndDate,'percent:',parseInt(percent), 'price:',parseInt(price))
    useEffect(() => {
        const callBack = (res)=> {
            if(res.Product){
                setDiscountFor("special")
                setProductIds(res.Product)
            }else setDiscountFor("all")

        }
        id ?
            dispatch(getDiscountCodeById({id},callBack))
            :
            dispatch(initDiscountCodeForm(FormDiscountCodeInit))
        return ()=>{
            dispatch(initDiscountCodeForm(FormDiscountCodeInit))
        }
    }, [id]);

    return (
        <Grid item xs={11} sm={12}
              className="w-100 d-flex flex-column DivParentCreateProduct ContentCreateAttribute">
            <ContainerHeader
                data={{
                    filter: false,
                    backBtn: true,
                }}
                headerTitle="افزودن کاربر"
                backBtnTitle="بازگشت"
                backBtnAction={backToUsers}
                // filterAction={(value) => {
                //     handleSearch(value);
                // }}
            />

            <Paper className="parentContentCreateProduct">
                <div className="w-100">

                    <div className="w-100">
                        <div className="d-flex flex-column">
                            <Grid container spacing={2}
                                  className="d-flex flex-wrap divParentContentBasicInformation mt-4">
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'نام'}
                                        variant="outlined"
                                        name={'name'}
                                        value={name}
                                        error={errors.name}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'کد'}
                                        variant="outlined"
                                        name={'code'}
                                        value={code}
                                        error={errors.code}
                                        className={`w-100`}
                                        onChange={setParametersMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        className={`DatePickerUserPanel ${errors.StartDate && "redBorder"}`}
                                        // timePicker={false}
                                        value={ StartDate !== null ? moment(StartDate , 'YYYY-MM-DD HH:mm:ss') : null }
                                        onChange={(e) => setTime(e, 'StartDate')}
                                        placeholder={`تاریخ شروع`}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <DatePicker
                                        isGregorian={false}
                                        className={`DatePickerUserPanel ${errors.EndDate && "redBorder"}`}
                                        // timePicker={false}
                                        value={ EndDate !== null ? moment(EndDate , 'YYYY-MM-DD HH:mm:ss') : null }
                                        onChange={(e) => setTime(e, 'EndDate')}
                                        placeholder={`تاریخ پایان`}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <TextField
                                        label={'تعداد'}
                                        variant="outlined"
                                        name={'Count'}
                                        value={Count}
                                        type="number"
                                        error={errors.Count}
                                        className={`w-100`}
                                        onChange={setParametersConditionMain}
                                    />
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    {percent !== undefined &&
                                    <Autocomplete
                                        className={`w-100`}
                                        value={provinces.find(data => data.value === "percent")}
                                        options={provinces}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, value) => {
                                            // checkFiled('typeDiscount', value);
                                            dispatch(onDiscountCodeFormChange({
                                                name: 'amount',
                                                value: {[value?.value]: ""}
                                            }))
                                            // if(value?.value === "percent"){
                                            //     dispatch(onDiscountCodeFormChange({name: 'amount', value:{percent: 0}}))
                                            // }dispatch(onDiscountCodeFormChange({name: 'amount', value:{price: 0}}))
                                        }}
                                        renderInput={(params) => (
                                            <TextField {...params}
                                                       variant="outlined"
                                                       className={`w-100`}
                                                       label="نوع تخفیف"/>
                                        )}
                                    />
                                    }
                                    {price !== undefined&&
                                        <Autocomplete
                                            className={`w-100`}
                                            value={ provinces.find(data=> data.value === "price") }
                                            options={provinces}
                                            getOptionLabel={(option) => option.name}
                                            onChange={(event, value) => {
                                                // checkFiled('typeDiscount', value);
                                                dispatch(onDiscountCodeFormChange({name: 'amount', value:{[value?.value]: ""}}))
                                                // if(value?.value === "percent"){
                                                //     dispatch(onDiscountCodeFormChange({name: 'amount', value:{percent: ""}}))
                                                // }dispatch(onDiscountCodeFormChange({name: 'amount', value:{price: ""}}))
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params}
                                                           variant="outlined"
                                                           className={`w-100`}
                                                           label="نوع تخفیف"/>
                                            )}
                                        />
                                    }

                                </Grid>

                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    {percent !== undefined &&
                                    <TextField
                                        label={'مقدار'}
                                        variant="outlined"
                                        name={'percent'}
                                        value={percent}
                                        type="number"
                                        // error={errors.count}
                                        className={`w-100`}
                                        onChange={setParametersAmountMain}
                                    />
                                    }
                                    {price !== undefined &&
                                        <TextField
                                            label={'مقدار'}
                                            variant="outlined"
                                            name={'price'}
                                            value={price}
                                            type="number"
                                            // error={errors.count}
                                            className={`w-100`}
                                            onChange={setParametersAmountMain}
                                        />
                                    }
                                </Grid>
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                checked={status === 1}
                                                name
                                                onChange={(e)=> {
                                                    const value = e.target.checked ? 1 : 0
                                                    dispatch(onDiscountCodeFormChange({
                                                        name: "status",
                                                        value: value
                                                    }))
                                                }
                                                }
                                            />
                                        }
                                        label="وضعیت"
                                    />
                                </Grid>

                                <Grid item
                                      xs={12} lg={12} xl={12}
                                      className="d-flex align-items-center"
                                >
                                    <FormControlLabel
                                        value="all"
                                        control={
                                            <Radio
                                                color="primary"
                                                checked={discountFor === "all"}
                                                onChange={(e)=> setDiscountFor(e.target.value)}
                                            />
                                        }
                                        label="تمام محصولات"
                                        labelPlacement="end"

                                    />
                                    <FormControlLabel
                                        value="special"
                                        control={
                                            <Radio
                                                color="primary"
                                                checked={discountFor === "special"}
                                                onChange={(e)=> setDiscountFor(e.target.value)}
                                            />
                                        }
                                        label="محصولات خاص"
                                        labelPlacement="end"

                                    />
                                </Grid>

                                {discountFor === "special" &&
                                <Grid item
                                      xs={12} lg={4} xl={4}
                                      className="d-flex justify-content-center align-items-center"
                                >
                                    <Autocomplete
                                        limitTags={2}
                                        multiple
                                        disableCloseOnSelect
                                        className="w-100"
                                        value={products.filter(x => productIds.some((id) => x.id === parseInt(id)))}
                                        getOptionLabel={(option) => option?.name}
                                        onChange={(event, newValue) => {
                                            // console.log(newValue)
                                            const newArray = newValue?.map((value) => value.id);
                                            setProductIds(newArray);
                                        }}
                                        options={products}
                                        loading={loading}
                                        renderTags={(tagValue, getTagProps) =>
                                            tagValue.map((option, index) => (
                                                <Chip
                                                    label={option?.name}
                                                    {...getTagProps({index})}
                                                />
                                            ))
                                        }
                                        renderInput={(params) =>
                                            <>
                                                <TextField {...params}
                                                    // error={errors?.category?.length > 0}
                                                           label={'نام محصول'}
                                                           variant="outlined"
                                                           type="text"
                                                           placeholder="انتخاب محصول"
                                                           onChange={onChangeSearchInput}
                                                           InputProps={{
                                                               ...params.InputProps,
                                                               endAdornment: (
                                                                   <React.Fragment>
                                                                       {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                                                       {params.InputProps.endAdornment}
                                                                   </React.Fragment>
                                                               ),
                                                           }}
                                                />
                                            </>
                                        }
                                    />
                                </Grid>
                                }

                                {/*<Grid item*/}
                                {/*      xs={12} lg={4} xl={4}*/}
                                {/*      className="d-flex justify-content-center align-items-center"*/}
                                {/*>*/}
                                {/*    <TextField*/}
                                {/*        label={'مقدار'}*/}
                                {/*        variant="outlined"*/}
                                {/*        name={'discountValue'}*/}
                                {/*        value={discountValue}*/}
                                {/*        error={errors.discountValue}*/}
                                {/*        className={`w-100`}*/}
                                {/*        onChange={setParametersMain}*/}
                                {/*    />*/}
                                {/*</Grid>*/}
                            </Grid>
                        </div>
                        <Button
                            variant="contained"
                            onClick={ id ? putDiscountCode : addDiscountCode }
                            className="continuationButtonCreateProduct mr-3 mt-5"
                        >
                            {id ? "ویرایش" : "ایجاد"}
                        </Button>
                    </div>
                </div>
            </Paper>
        </Grid>
    );
}
